export const MatterStatus = {
	open: 'Open',
	probation: 'Probation',
	closed: 'Closed',
}

export const CriminalHistory = {
	1: `I (0 or 1 points)`,
	2: `II (2 or 3 points)`,
	3: `III (4-6 points)`,
	4: `IV (7-9 points)`,
	5: `V (10-12 points)`,
	6: `VI (13 or more points)`,
}

export const RevocationGrade = {
	a1: `Grade A(1)`,
	a2: `Grade A(2)`,
	b: `Grade B`,
	c: `Grade C`,
}

export const AdjustmentType = {
	general: 'General',
	global: 'Case Level',
}

export const UserLevel = {
	admin: `Admin`,
	manager: `Manager`,
	user: `User`,
	guest: `Guest`,
}

export const UserStatus = {
	active: `Active`,
	inactive: `Inactive`,
	trial: `Trial`,
	expired: `Expired`,
}

export const OrganizationStatus = {
	active: `Active`,
	inactive: `Inactive`,
	trial: `Trial`,
	expired: `Expired`,
}

export const OrganizationMemberStatus = {
	active: `Active`,
	inactive: `Inactive`,
}

export const OrganizationMemberAccess = {
	admin: `Admin`,
	manager: `Manager`,
	member: `Member`,
}

export const CustomerStatus = {
	active: `Active`,
	inactive: `Inactive`,
	trial: `Trial`,
	expired: `Expired`,
}

export const CustomerMemberStatus = {
	active: `Active`,
	inactive: `Inactive`,
	pending: `Pending`,
}

export const CustomerSubscriptionStatus = {
	active: `Active`,
	inactive: `Inactive`,
	pending: `Pending`,
	trialing: `Trial`,
}

export const CustomerMemberAccess = {
	// admin: `Admin`,
	manager: `Manager`,
	user: `User`,
}

export const Versions = {
	'2025': '2025',
	'2024': '2024',
	// '2023': '2023',
	// '2021': '2021',
	// '2018': '2018',
}

export const Circuits = {
	federal: `Supreme Court`,
	dc: `D.C.`,
	'1': `1st Circuit`,
	'2': `2nd Circuit`,
	'3': `3rd Circuit`,
	'4': `4th Circuit`,
	'5': `5th Circuit`,
	'6': `6th Circuit`,
	'7': `7th Circuit`,
	'8': `8th Circuit`,
	'9': `9th Circuit`,
	'10': `10th Circuit`,
	'11': `11th Circuit`
}

export const toOptions = (enums) => {
	return Object.keys(enums).map(k => ({
		value: k,
		label: enums[k]
	}))

}
